import InputField from "../../../../components/InputField"
import Button from "../../../../components/Button"
import customSelectStyles from "components/CustomSelect/CustomSelectStyle"
import Select from "react-select"
import Modal from "react-bootstrap/Modal"
import Toast from "components/Toast"
import React, { useEffect, useState } from "react"
import ToggleSwitch from "components/ToggleSwitch"
import { addPaytmTerminal, updatePaytmTerminal } from "core/services/api"
import "./AddOrEditTerminal.scss"

export default function PaytmTermialForm(props: any) {
  const { paytmTerminalId, paytmTerminals, closePrintModal, show, centerPaytmMerchantId, managePaytmMerchantInfo } = props
  const [success, setSuccess] = useState<boolean>(false)
  const [message, setMessage] = useState<string>("")
  const [toastType, setToastType] = useState<string>("")
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [formErrors, setFormErrors] = useState<any>()
  const [isSubmit, setIsSubmit] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState<any>(false)
  const [paytmTerminal, setPaytmTerminal] = useState<any>({
    id: "",
    name: "",
    centerId: "",
    centerPaytmMerchantId: "",
    terminalId: "",
    description: "",
    status: "",
    appointmentTypes: [],
    isDefault: false
  });

  const appointmentTypes: any = [
    "OPD",
    "IPD",
    "HC",
  ].map((ele: any) => {
    return { label: ele, value: ele }
  })

  useEffect(() => {
    if (paytmTerminalId) {
      const terminal = paytmTerminals.find((term: any) => term.id === paytmTerminalId);
      console.log("terminal", terminal)
      if (terminal)
        setPaytmTerminal({
          id: terminal?.id,
          name: terminal?.name,
          centerPaytmMerchantId: terminal?.centerPaytmMerchantId,
          terminalId: terminal?.terminalId,
          description: terminal?.description,
          status: terminal?.status,
          centerId: terminal?.centerId,
          appointmentTypes: terminal?.appointmentTypes?.map((ele: any) => ({ label: ele, value: ele })),
          isDefault: terminal?.isDefault || false
        })
    }
  }, [])


  useEffect(() => {
    console.log(formErrors, isSubmit)
    if (formErrors && Object.keys(formErrors).length === 0 && isSubmit) {
      let test: any = {
        name: paytmTerminal?.name?.trim(),
        terminalId: paytmTerminal?.terminalId,
        description: paytmTerminal?.description,
        status: paytmTerminal?.status,
        centerPaytmMerchantId: centerPaytmMerchantId || paytmTerminal?.centerPaytmMerchantId,
        isDefault: paytmTerminal?.isDefault,
        appointmentTypes: paytmTerminal?.appointmentTypes?.map((ele: any) => ele.value),
        centerId: managePaytmMerchantInfo?.centerId || paytmTerminal?.centerId,
      }
      setIsLoading(true)
      if (!paytmTerminalId) {
        addPaytmTerminal(test)
          .then((data) => {
            setIsLoading(false)
            setMessage("Paytm Terminal Created Successfully")
            setToastType("success")
            setSuccess(true)
          })
          .catch((err) => {
            setIsLoading(false)
            setMessage(err?.response?.data?.message)
            setToastType("error")
            setSuccess(true)
          })
      } else {
        updatePaytmTerminal(paytmTerminalId, test)
          .then((data) => {
            setIsLoading(false)
            setMessage("Paytm Terminal Updated Successfully")
            setToastType("success")
            setSuccess(true)
          })
          .catch((err: any) => {
            setIsLoading(false)
            setMessage(err?.response?.data?.message)
            setToastType("error")
            setSuccess(true)
          })
      }
    }
  }, [formErrors])

  const validate = (values: any) => {
    const errors: any = {}

    if (!values?.name) {
      errors["name"] = "Name is required"
    }

    if (!values?.terminalId) {
      errors["terminalId"] = "Terminal ID is required"
    }

    if (!values?.description) {
      errors["description"] = "Description is required"
    }

    if (!values?.status) {
      errors["status"] = "Status is required"
    }

    if (!values?.appointmentTypes || values?.appointmentTypes?.length === 0) {
      errors["appointmentTypes"] = "Atleast one Appointment Type is required"
    }

    return errors
  }

  const handleSubmit = (e: any) => {
    e.stopPropagation()
    e.preventDefault()
    setFormErrors(validate(paytmTerminal))
    setIsSubmit(true)
  }

  const handleClose = () => {
    closePrintModal(false)
  }


  const paytmMerchantStatus: string[] = ["ACTIVE", "INACTIVE"]

  const s = paytmMerchantStatus.map((ele: any) => {
    return { label: ele, value: ele }
  })

  return (
    <div>
      <Modal size="xl" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> {paytmTerminalId ? `Edit Paytm Terminal` : `Add Paytm Terminal`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="edit-manage-terminal-wrapper">
            <form onSubmit={handleSubmit}>
              <div className="edit-details-wrapper">
                <div className="edit-details-container">
                  <div className="manage-details">
                    <div className="col-md-6 col-lg-6 staff_details">
                      <div>
                        <label className="textlabel"> Center:</label>
                      </div>
                      <InputField
                        className="col-md-10"
                        placeholder="Center"
                        readOnly={true}
                        value={managePaytmMerchantInfo?.centerName}
                        handleChange={() => {

                        }}
                      />
                    </div>
                    <div className="col-md-6 col-lg-6 staff_details">
                      <div>
                        <label className="textlabel">* Name:</label>
                      </div>
                      <InputField
                        className="col-md-10"
                        placeholder="Name"
                        value={paytmTerminal?.name}
                        handleChange={(e) => {
                          setPaytmTerminal({
                            ...paytmTerminal,
                            name: e.target.value,
                          })
                        }}
                        errorMsg={formErrors?.name}
                      />
                    </div>
                    <div className="col-md-6 col-lg-6 staff_details">
                      <div>
                        <label className="textlabel">* Terminal ID:</label>
                      </div>
                      <InputField
                        className="col-md-10"
                        placeholder="Terminal ID"
                        value={paytmTerminal?.terminalId}
                        handleChange={(e) => {
                          setPaytmTerminal({
                            ...paytmTerminal,
                            terminalId: e.target.value,
                          })
                        }}
                        errorMsg={formErrors?.terminalId}
                      />
                    </div>
                    <div className="col-md-6 col-lg-6 staff_details">
                      <div>
                        <label className="textlabel">* Description:</label>
                      </div>
                      <InputField
                        className="col-md-10"
                        placeholder="Description"
                        value={paytmTerminal?.description}
                        handleChange={(e) => {
                          setPaytmTerminal({
                            ...paytmTerminal,
                            description: e.target.value,
                          })
                        }}
                        errorMsg={formErrors?.description}
                      />
                    </div>
                    <div className="col-md-6 col-lg-6 staff_details">
                      <div>
                        <label className="textlabel">* Appointment Types:</label>
                      </div>
                      <div className="col-md-10">
                        <Select
                          styles={customSelectStyles()}
                          options={[...appointmentTypes]}
                          value={paytmTerminal?.appointmentTypes}
                          onChange={(option) => {
                            let filteredArray = [...option];
                            setPaytmTerminal({
                              ...paytmTerminal,
                              appointmentTypes: filteredArray,
                            });
                          }}
                          isMulti
                          onFocus={() => {
                            setIsMenuOpen(true)
                          }}
                          onBlur={() => {
                            setIsMenuOpen(false)
                          }}
                          menuIsOpen={isMenuOpen}
                        />
                        {formErrors?.appointmentTypes && (
                          <span className="error-staff">{formErrors?.appointmentTypes}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6 staff_details">
                      <div>
                        <label className="textlabel">* Status:</label>
                      </div>
                      <div className="col-md-10">
                        <Select
                          styles={customSelectStyles()}
                          value={s.filter((p: any) => {
                            return p.value === paytmTerminal?.status ? p.label : "";
                          })}
                          placeholder="Select status"
                          options={s}
                          onChange={(option: any) => {
                            console.log("option", option)
                            setPaytmTerminal({
                              ...paytmTerminal,
                              status: option?.value,
                            })
                          }}
                        />
                        <span className="error-staff">{formErrors?.status}</span>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6 staff_details">
                      <div>
                        <label className="textlabel"> Is Default:</label>
                      </div>
                      <div className="col-md-10">
                        <div className="vip">
                          <ToggleSwitch
                            checked={paytmTerminal?.isDefault}
                            onChange={(e: any) =>
                              setPaytmTerminal({
                                ...paytmTerminal,
                                isDefault: e.target.checked,
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="button-alignment">
                    <div>
                      <Button
                        text="Cancel"
                        type={"button"}
                        outline={true}
                        onClick={() => closePrintModal(false)}
                        id="cancel"
                      />
                    </div>
                    <div>
                      <Button
                        text={paytmTerminalId ? "Update" : "Save"}
                        type="submit"
                        id="save"
                      />
                    </div>

                  </div>
                </div>
              </div>
            </form >
          </div>
        </Modal.Body>
      </Modal>
      {success ? (
        <><div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9998,
          }}
        >
        </div>
          <Toast
            textMessage={message}
            onCloseText={"Close"}
            onClose={() => {
              setSuccess(false)
              if (toastType === "success") {
                handleClose()
              }

            }}
            type={toastType}
          ></Toast></>
      ) : isLoading ? (
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "50%",
          }}
        >
          <div
            style={{ width: "3rem", height: "3rem" }}
            className="spinner-border text-primary"
          ></div>
        </div>
      ) : (
        ""
      )}
    </div>
  )

}